// TODO: may need to give modal the ability to have a sub-view / views
// ... current uses have it overridable or have content that doesn't require interaction
// this is extending the existing modal dialog directly

// TODO: when modal is open, disable document keyboard events -- currently used in mousetrap

var Modal = require('../../common/modal/modal'),
    _ = require('underscore'),
    Util = require('../../FV/util');

require('./style.less');

module.exports = Modal.extend({
    baseModalDefaults: {
        title: 'Delete Page'
    },
    contentTemplate: require('./template.hbs'),
    initialize: function(options) {

        // what is used to validate entered page numbers
        this.numberPagesInDocument = options.numberPagesInDocument;

        this.settings = _.extend( {}, {
            content: this.contentTemplate( this.serializeContentTemplateData() )
        }, options );

        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );

        return this;
    },

    serializeContentTemplateData: function() {
        return {
            randomInputName: Util.getUniqueStrToDisableFormAutoComplete()
        };
    },

    ui: _.extend( {}, Modal.prototype.ui, {
        form:                   '#delete-pgs-form',
        currentPgCheckbox:      '#delete-current-pg-cb',
        pageRangeCheckbox:      '#delete-pg-range-cb',
        radioButtons:           '.delete-pgs-radio',
        pageRangeInput:         '#delete-pg-range-input',

        // may want to make validation and these common ...
        errorMessageWr:         '#delete-pgs-err-msg-wr',
        errorMessageTxt:        '#delete-pgs-err-msg-txt'
    }),

    events: _.extend( {} , Modal.prototype.events, {
        'submit @ui.form':                  'onFormSubmit',
        'change @ui.radioButtons':          'onRadioBtnChange'
    }),

    onFormSubmit: function(e) {
        // simulate 'ok' -- not optimal or most symantic (buttons are outside it)
        // but at least will capture the enter key when the selection range input is focused
        /// ... in the future ...
        e.preventDefault();
        this.ok();
    },

    onRadioBtnChange: function(e) {
        var pageRangeSelected = $(e.target)[0] === this.ui.pageRangeCheckbox[0];
        this.ui.pageRangeInput.attr( 'disabled', !pageRangeSelected );
        pageRangeSelected &&  this.ui.pageRangeInput.select();
    },

    ok: function() {

        if (  this.ui.currentPgCheckbox.is(':checked') ) {
            this.destroy();
            this.settings.okCB( 'currentPage' );
            return;
        }

        var pgsToDelete = this.getPagesToDelete( this.ui.pageRangeInput.val() );

        if (typeof pgsToDelete === 'string') {
            this._showValidationErrorMsg(pgsToDelete);
        } else {
            this.destroy();
            this.settings.okCB( pgsToDelete );
        }

    },
    _showValidationErrorMsg: function(msg) {
        this.ui.errorMessageWr.removeClass('hide'); // could make top level in css
        this.ui.errorMessageTxt.html(msg);
    },

    // If the range is invalid, return an error message.
    // Otherwise, return an array of page numbers to delete.
    getPagesToDelete: function(range) {

        if (!range)
            return 'Page Range Required';

        // remove any spaces -- expression below allows for spaces in the middle of reg ex but not at beg or end
        range = range.replace(/\s/g, '');

        // https://stackoverflow.com/questions/25931053/validate-page-numbers-ranges-for-printing
        // https://regex101.com/r/lS8vP9/3

        var re = /^(?!([ \d]*-){2})\d+(?: *[-,] *\d+)*$/gm;  // If use actual #'s, could make the expression a variable and put those in there ...
        if (!re.test(range))
            return 'Invalid Page Range';

        // Handle Duplicate Page Numbers -- just add to the dupes
        // Handle Page Numbers Exist (including 0) -- show error ...
        // Handle range if its of the same page (1-1), should be 1 ...
        // Handle leading 0s in numbers (parseInt should get this)

        var aPgs = [], // array of pages to return, (all are valid -- exist in the document)
            invalidPgs = [];

        _.each( range.split(','), function(section) {

            if ( section.indexOf('-') < 1 ) {

                //single page
                var pgNum = parseInt(section);  // handles leading zeroes and make an integer

                validatePageNumber(pgNum, this.numberPagesInDocument)
                    ? aPgs.push( pgNum )
                    : invalidPgs.push( pgNum );

            } else {

                //range
                var pgs = section.split('-'),
                    pg1 = parseInt( pgs[0] ),
                    pg2 = parseInt( pgs[1] ),
                    pg1IsValid = validatePageNumber(pg1, this.numberPagesInDocument),
                    pg2IsValid = validatePageNumber(pg2, this.numberPagesInDocument);

                if (pg1IsValid && pg2IsValid) {

                    // both pages are valid: push the range of numbers between them
                    var pgMin = Math.min( pg1, pg2 ),
                        pgMax = Math.max( pg1, pg2 ),
                        pagesInRange = _.range( pgMin,  pgMax );

                    // underscore range 'start' is inclusive, 'stop' is exclusive, so always add the last one to the end
                    aPgs.push.apply( aPgs, pagesInRange.concat(pgMax) );

                    // maybe want to add pages that were in the range if some weren't .... now hard failing on there
                    // should those valid and in between be pushed in as valid???

                } else {

                    pg1IsValid ? aPgs.push( pg1 ) : invalidPgs.push( pg1 );
                    pg2IsValid ? aPgs.push( pg2 ) : invalidPgs.push( pg2 );

                }

            }

        }, this );

        aPgs = _.uniq(aPgs);   // remove any dupes
        aPgs = _.sortBy(aPgs, function(n) { return n; });

        invalidPgs = _.uniq(invalidPgs);
        invalidPgs = _.sortBy(invalidPgs, function(n) { return n; });

        // could make friendlier error message -- pages from x-y, --- make another string, example:
        var nInvalidPgs = invalidPgs.length;
        if (nInvalidPgs > 0)
            return 'The following page' + (nInvalidPgs > 1 ? 's do' : ' does') + ' not exist in the document: ' + invalidPgs.join(', ');

        return aPgs;

        function validatePageNumber(n, nPagesInDoc) {
            return n > 0 && n <= nPagesInDoc;
        }

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/deletePages/view.js
 ** module id = 109
 ** module chunks = 0
 **/